export default "__VITE_ASSET__BHqSl4B4__"